import * as React from "react";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  resolveNumber,
  useCurrentCase,
  useDispatch,
  useParams
} from "duck";
import { useUpdateMonitoringMutation } from "requests";

export const useUpdateMonitoring = (monitoringId: number) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdateMonitoringMutation();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return React.useCallback<FormWatcherCallback<{ doctor: number | null }>>(
    values => {
      dispatch(
        casesActions.updateMonitoring({
          data: {
            _id: monitoringId,
            monitoringBy: {
              _id: resolveNumber(values.doctor) as number
            }
          },
          _id: caseId
        })
      );

      if (shouldSync) {
        return update({
          variables: {
            input: {
              _id: monitoringId,
              monitoringBy: resolveNumber(values.doctor)
            }
          }
        });
      }
    },
    [monitoringId, update, shouldSync]
  );
};
